module.exports = __webpack_public_path__ + "img/civil-technology.7968a7b1.svg";